import { assertNotEmpty, type Optional } from '@festina-life/core'

import { useTemplateContext } from '../../context/templateContext'
import type { TemplateVersion } from '../../types/templateModel'
import { EditableMarkdownViewer } from '../markdownEditor/EditableMarkdownViewer'

type Props = {
  templateVersion: TemplateVersion
}

export const TemplateVersionDocumentationEditor = ({
  templateVersion: { documentation, ...otherFields },
}: Props) => {
  const { isDraftTemplate, templateVersion } = useTemplateContext()
  assertNotEmpty(templateVersion?.versionInfo)

  const handleSaveDocumentation = async (
    updatedDocumentation: Optional<string>,
  ) => {
    await otherFields.updateTemplate({
      ...otherFields,
      ...(updatedDocumentation
        ? {
            documentation: {
              value: updatedDocumentation,
              origin: `${otherFields.path}.documentation`,
            },
          }
        : {}),
    })
  }

  return (
    <EditableMarkdownViewer
      key={documentation?.value}
      value={documentation?.value}
      onSave={isDraftTemplate ? handleSaveDocumentation : undefined}
    />
  )
}
